import { render } from "./EditAssignedMember.vue?vue&type=template&id=2f09c84b&ts=true"
import script from "./EditAssignedMember.vue?vue&type=script&lang=ts"
export * from "./EditAssignedMember.vue?vue&type=script&lang=ts"

import "./EditAssignedMember.vue?vue&type=style&index=0&id=2f09c84b&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__